module.exports = __webpack_public_path__ + "img/bf43e16.jpg";